import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import HRSidebar from "../HRSidebar/HRSidebar";

const HRLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<HRSidebar />}>{children}</NavigationBar>
);

export default HRLayout;
